import { motion } from "framer-motion";
import React, { useRef, useEffect, useState } from "react";

const FadeInWhenVisible = ({ children }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkIfMobile = () => window.innerWidth <= 768;
    const isMobileDevice = checkIfMobile();
    setIsMobile(isMobileDevice);
    
    if (isMobileDevice) {
      setIsVisible(true); 
      return;
    }

    // Store current ref value in a variable
    const currentRef = ref.current;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Use the stored ref value
          if (currentRef) {
            observer.unobserve(currentRef);
          }
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    // Optional: Handle window resize
    const handleResize = () => {
      const nowMobile = checkIfMobile();
      if (nowMobile !== isMobileDevice) {
        setIsMobile(nowMobile);
        if (nowMobile) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      // Use the stored ref value in cleanup
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (isMobile) {
    return <div ref={ref}>{children}</div>;
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 1, ease: "easeOut" }}
      style={{ minHeight: "100px" }}
    >
      {children}
    </motion.div>
  );
};

export default FadeInWhenVisible;